import { DeviceStatusesGetRequestParams } from "@lib/core";

export interface DeviceStatusDefaultParams extends DeviceStatusesGetRequestParams { }
export class DeviceStatusDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "sort_order.asc,id.asc";
  }
}